import React from "react";
import { translate } from "react-i18next";
import * as R from "ramda";

import { Box, Flex, Link, Text } from "src/components";
import { Button } from "src/components/Form";
import { defaultPrevented } from "src/utils";

import { useOutOfBand } from "../hooks";

import { getDefaultNickname } from "src/sdk";

import { DynamicForm } from "src/components/Form";
import ChannelSelection from "src/banking/authentication/ChannelSelection";

import {
  tier3OOBFields,
  deviceOOBFields,
} from "src/banking/authentication/sharedFields";

// This allows a CODE to be passed via an environment variable during
// development.
const initialValues = {
  code: process.env.CODE || "",
  remember: true,
  nickname: getDefaultNickname(),
};

const fields = {
  Device: deviceOOBFields,
  Tier3: tier3OOBFields,
};

const DeviceSetupForm = translate("translations")(
  ({ challengeType, t, onSubmit, ...props }) => {
    const onSubmitType = (values, formikProps) => {
      if (challengeType === "Device") {
        const valuesToSubmit = {
          code: values.code,
          nickname: values.remember ? values.nickname : undefined,
        };

        return onSubmit(valuesToSubmit, formikProps);
      }

      return onSubmit(
        {
          code: values.code,
        },
        formikProps
      );
    };

    return (
      <Flex p={2} flexDirection="column">
        <Text fontWeight="semibold" fontSize={4} mb={2}>
          What code did we send you?
        </Text>
        <DynamicForm
          formKey="outOfBand"
          fields={fields[challengeType]}
          needsCaptcha={false}
          initialValues={initialValues}
          onSubmit={onSubmitType}
          {...props}
        />
        <Link
          to="#"
          color="green"
          mt={2}
          align="center"
          fontSize={2}
          onClick={defaultPrevented(props.requestNewCode)}
        >
          {t("olb.security.resendCode")}
        </Link>
      </Flex>
    );
  }
);

const ChannelSelectionInstructions = translate("translations")(({ t }) => (
  <Box mb={1}>
    <Text fontSize={3} mb={2}>
      {t("olb.login.forgotDescription")}
    </Text>
    <Text fontWeight="semibold" fontSize={4}>
      {t("olb.login.channelDescription")}
    </Text>
  </Box>
));

const OutOfBand = props => {
  const { sent, sending, onSelectChannel, requestNewCode } = props.outOfBand;

  if (sent) {
    const challengeType = R.findLast(
      R.compose(
        R.not,
        R.isEmpty
      ),
      props.loginState.links[props.loginState.state].split("/")
    );
    return (
      <DeviceSetupForm
        {...props}
        requestNewCode={requestNewCode}
        challengeType={challengeType}
      />
    );
  }

  return (
    <ChannelSelection
      {...props}
      availableChannels={props.loginState.availableChannels}
      sending={sending}
      onSelectChannel={onSelectChannel}
      renderAboveChannelSelection={props => (
        <ChannelSelectionInstructions {...props} />
      )}
    />
  );
};

export default OutOfBand;



// WEBPACK FOOTER //
// ./src/banking/authentication/Login/steps/OutOfBand.js